export const STUDENT_PROGRESS_WIDGET = {
  StudentProgressBarWidget: 'StudentProgressBarWidget',
  StudentProgressSummaryChartWidget: 'StudentProgressSummaryChartWidget',
  StudentProgressTrophiesWidget: 'StudentProgressTrophiesWidget',
  StudentProgressWeeklyPerformanceChartWidget: 'StudentProgressWeeklyPerformanceChartWidget'
};

// Default trophy tiers (Gallopade / legacy behavior). Override via satellite layout JSON
// `studentProgressTrophyTiers`. Tiers are evaluated highest `minScore` first; a score
// counts toward at most one tier.
// Each entry: { id: string, minScore: number, imageUrl?: string, showBand?: boolean }
export const DEFAULT_STUDENT_PROGRESS_TROPHY_TIERS = [
  { id: 'gold', minScore: 80, showBand: true },
  { id: 'silver', minScore: 60, showBand: true }
];
